import { create } from "zustand";
import ICoreBundle from "../interfaces/ICoreBundle";
import { BundleElement } from "./elementBundlesStore";

/** What the bundle inspector shows: the cursor tooltip while hovering, and the bundle panel once an element is pinned. */
interface BundleInspectorState {
    // For both: null when nothing is hovered or pinned; empty when the element has no bundle
    bundles: ICoreBundle[] | null;
    pinnedBundles: ICoreBundle[] | null;
    pinnedElements: BundleElement[];    // The elements of the pinned bundle; empty unless exactly one is pinned
    onUnpin: (() => void) | null;   // The panel's close button
    onDetach: (() => void) | null;  // The panel's "Detach elements"; null when the user can't detach

    setHoveredBundles: (bundles: ICoreBundle[]) => void;
    clearHovered: () => void;
    setPinned: (bundles: ICoreBundle[], elements: BundleElement[], onUnpin: () => void, onDetach?: (() => void) | null) => void;
    clearPinned: () => void;
}

export const useBundleInspectorStore = create<BundleInspectorState>()((set) => ({
    bundles: null,
    pinnedBundles: null,
    pinnedElements: [],
    onUnpin: null,
    onDetach: null,

    setHoveredBundles: (bundles) => set({ bundles }),
    clearHovered: () => set({ bundles: null }),
    setPinned: (pinnedBundles, pinnedElements, onUnpin, onDetach = null) => set({ pinnedBundles, pinnedElements, onUnpin, onDetach }),
    clearPinned: () => set({ pinnedBundles: null, pinnedElements: [], onUnpin: null, onDetach: null }),
}));
